import React from 'react';
import CampoNumero from './CampoNumero';
import { simboloMoneda } from '../services/negocioActual';
import { useCategorias } from '../context/CategoriasContext';
import { comboValido, normalizarCombo } from '../utils/tiendaCombos';

const caja = { marginBottom: '16px', padding: '16px', background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: '14px' };
const label = { display: 'block', margin: '12px 0 6px', fontSize: '13px', fontWeight: 700, color: '#374151' };
const input = { width: '100%', padding: '11px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', background: 'white' };

// "2026-10-29T02:00:00Z" ↔ valor de <input type="datetime-local"> (hora del celular).
const aLocal = (iso) => {
  if (!iso) return '';
  const d = new Date(iso); if (Number.isNaN(d.getTime())) return '';
  const z = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(d.getHours())}:${z(d.getMinutes())}`;
};
const deLocal = (v) => { if (!v) return null; const d = new Date(v); return Number.isNaN(d.getTime()) ? null : d.toISOString(); };

// 🎁 Combos de la tienda en línea: "3 por L 399". La bolsa lo aplica sola
// y el pedido llega a Kontrol con el precio del combo.
export default function CombosTiendaConfig({ combos, onCambiar, guardando }) {
  const { categorias } = useCategorias();
  const s = simboloMoneda();
  const lista = (combos && Array.isArray(combos.combos)) ? combos.combos : [];
  const dinero = (n) => `${s} ${Number(n || 0).toLocaleString('es-HN', { maximumFractionDigits: 2 })}`;
  const cambiar = (i, campo, valor) => onCambiar({ combos: lista.map((c, j) => (j === i ? { ...c, [campo]: valor } : c)) });
  const agregar = () => onCambiar({ combos: [...lista, { activo: true, cantidad: 3, precio: '', precioPieza: '', categorias: [], hasta: null }] });
  const quitar = (i) => onCambiar({ combos: lista.filter((_, j) => j !== i) });

  return (
    <div style={caja}>
      <div style={{ fontWeight: 700, fontSize: '15px' }}>🎁 Combos de tu tienda en línea</div>
      <p style={{ margin: '4px 0 12px', fontSize: '12px', color: '#6B7280' }}>
        Ej: "3 por {s} 399" en las piezas de {s} 150. La bolsa aplica el descuento sola y tu clienta lo ve antes de pedir.
      </p>

      {lista.map((c, i) => {
        const n = normalizarCombo(c, s);
        const ok = comboValido(n);
        const ahorro = n.cantidad * n.precioPieza - n.precio;
        return (
          <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '12px 14px', marginBottom: '10px', border: '1px solid #FED7AA' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
              <label style={{ display: 'flex', gap: '8px', alignItems: 'center', fontWeight: 700, fontSize: '14px', cursor: 'pointer' }}>
                <input type="checkbox" checked={c.activo !== false} disabled={guardando} onChange={(e) => cambiar(i, 'activo', e.target.checked)}
                  style={{ width: '18px', height: '18px', accentColor: '#C2410C' }} />
                {c.activo !== false ? 'Activo' : 'Apagado'}
              </label>
              <button type="button" className="k-btn-ghost" disabled={guardando} onClick={() => quitar(i)}>🗑️ Quitar</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '0 12px' }}>
              <div>
                <label style={label}>Lleva</label>
                <select value={n.cantidad} disabled={guardando} onChange={(e) => cambiar(i, 'cantidad', Number(e.target.value))} style={input}>
                  {[2, 3, 4, 5, 6].map((k) => <option key={k} value={k}>{k} piezas</option>)}
                </select>
              </div>
              <div>
                <label style={label}>Por (precio del combo)</label>
                <CampoNumero valor={c.precio === '' || c.precio == null ? '' : String(c.precio)} onChange={(v) => cambiar(i, 'precio', v)}
                  prefijo={s} min={0} max={1000000} deshabilitado={guardando} estilo={input} />
              </div>
              <div>
                <label style={label}>En las piezas de</label>
                <CampoNumero valor={c.precioPieza === '' || c.precioPieza == null ? '' : String(c.precioPieza)} onChange={(v) => cambiar(i, 'precioPieza', v)}
                  prefijo={s} min={0} max={1000000} deshabilitado={guardando} estilo={input} />
              </div>
              <div>
                <label style={label}>Termina (opcional)</label>
                <input type="datetime-local" value={aLocal(c.hasta)} disabled={guardando} onChange={(e) => cambiar(i, 'hasta', deLocal(e.target.value))} style={input} />
              </div>
            </div>
            <label style={label}>Solo en estas categorías (si no eliges, aplica en todas)</label>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {categorias.map((cat) => {
                const sel = n.categorias.includes(cat.nombre);
                return (
                  <button key={cat.id} type="button" disabled={guardando}
                    onClick={() => cambiar(i, 'categorias', sel ? n.categorias.filter((x) => x !== cat.nombre) : [...n.categorias, cat.nombre])}
                    style={{ padding: '6px 12px', borderRadius: '999px', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit',
                      border: `1.5px solid ${sel ? '#C2410C' : '#E5E7EB'}`, background: sel ? '#FFEDD5' : 'white', color: sel ? '#9A3412' : '#374151', fontWeight: sel ? 700 : 400 }}>
                    {cat.nombre}
                  </button>
                );
              })}
            </div>
            <p style={{ margin: '12px 0 0', padding: '10px 12px', borderRadius: '10px', background: ok ? '#FFF7ED' : '#FEF2F2', fontSize: '13px', color: ok ? '#9A3412' : '#B91C1C' }}>
              {n.precio > 0 && n.precioPieza > 0 && n.precio >= n.cantidad * n.precioPieza
                ? `⚠️ ${n.cantidad} piezas de ${dinero(n.precioPieza)} ya suman ${dinero(n.cantidad * n.precioPieza)}: el combo tiene que costar menos.`
                : !(n.precio > 0 && n.precioPieza > 0) ? 'Escribe el precio del combo y el precio de las piezas que entran.'
                  : c.activo === false ? 'Apagado: tu clienta no lo ve.'
                    : n.hasta && new Date() > new Date(n.hasta) ? 'Ya terminó: tu clienta no lo ve.'
                      : <>Tu clienta verá: <b>🎁 Llévate {n.nombre}</b> en las piezas de {dinero(n.precioPieza)}{n.categorias.length ? ` (${n.categorias.join(', ')})` : ''} · ahorra {dinero(ahorro)}</>}
            </p>
          </div>
        );
      })}

      {lista.length < 5 && (
        <button type="button" className="k-btn-soft" disabled={guardando} onClick={agregar}>➕ Agregar combo</button>
      )}
      <p style={{ margin: '8px 0 0', fontSize: '12px', color: '#9CA3AF' }}>Revisa que el precio del combo quede arriba de lo que te cuestan las piezas.</p>
    </div>
  );
}
